import * as t from "io-ts";

export const tFile = t.strict({
  id: t.number,
  link: t.string,
});

export type File = t.TypeOf<typeof tFile>;
